import axios from "axios";
import API_URL from "./apiUrl";

export const axiosClient = axios.create({
  baseURL: API_URL.superStudentApplication,
  headers: {
    // "Content-Type": "application/json",
    'Accept': 'application/json',
    'Authorization': `Bearer ${API_URL.isMakassarKey}`
  },
});

export const axiosClientSuperStudent = axios.create({
  baseURL: API_URL.superStudent,
  headers: {
    'Accept': 'application/json',
    'Authorization': `Bearer ${API_URL.ambassadorKey}`
  }
});

export const axiosClientEvent = axios.create({
  baseURL: API_URL.superStudent,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ`
  }
});

export const axiosRecap = axios.create({
  baseURL: API_URL.BASEURL,
  headers: {
    'Authorization': `Bearer ${API_URL.masterKey}`  //TOKEN NYAA GA ADA!!!
  },
});